import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getDestinationsByCountry = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const { countryId } = data;
        const response = await api('get', `destination/${countryId}`);
        return response.data || [];
    });
